<template>
    <div>
        <li class="header">NAVIGASI UTAMA</li>

                <li class="active">
                    <router-link to="/office">
                        <i class="material-icons">home</i>
                        <span>Home</span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/office_agenda_masuk">
                        <i class="material-icons">assignment_returned</i>
                        <span>Agenda Masuk</span>
                        <span class="label-count bg-grey f_badges">9</span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/office_agenda_keluar">
                        <i class="material-icons">assignment_return</i>
                        <span>Agenda Keluar</span>
                        <span class="label-count bg-grey f_badges">9</span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/office_surat_masuk" >
                        <i class="material-icons">mail</i>
                        <span>Surat Masuk</span>
                        <span class="label-count bg-grey f_badges">15</span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/office_surat_kirim">
                        <i class="material-icons">send</i>
                        <span>Surat Kirim</span>
                        <span class="label-count bg-grey f_badges">9</span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/office_validasi_surat">
                        <i class="material-icons">thumb_up</i>
                        <span>Validasi Surat</span>
                        <span class="label-count bg-grey f_badges">9</span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/office_surat_terusan">
                        <i class="material-icons">drafts</i>
                        <span>Surat Terusan</span>
                        <span class="label-count bg-grey f_badges">9</span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/office_ttd_surat">
                        <i class="material-icons">touch_app</i>
                        <span>TandaTangan Surat</span>
                        <span class="label-count bg-grey f_badges">9</span>
                    </router-link>
                </li>



    
                <li class="header">DATA MASTER</li>
                <li>
                    <a href="javascript:void(0);" class="menu-toggle">
                        <i class="material-icons col-deep-orange">assignment_returned</i>
                        <span>Data Master</span>
                    </a>
                    <ul class="ml-menu">
                        <li>
                            <router-link to="/office_user">User</router-link>
                        </li>
                        <li>
                            <router-link to="/office_borang_acu">Borang Acu</router-link>
                        </li>

                    </ul>
                </li>
                

                <li>
                    <a href="javascript:void(0);">
                        <i class="material-icons col-amber">settings</i>
                        <span>Pengaturan</span>
                    </a>
                </li>

    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
